module.exports = __webpack_public_path__ + "img/clothing18.7dec12f7.jpg";